/**
 *
 * FlexFormField
 *
 */

import React, { useState, useEffect } from 'react';

import {
  Form,
  Input,
  Button,
  Grid,
  TextArea,
  Icon,
  Image,
  Dropdown,
  Label,
  Divider,
  Checkbox,
  Popup,
} from 'semantic-ui-react';
import styles from './styles.module.css';
import lodash from 'lodash';
import FlexTable from '../../common/FlexTable';
import PriceInput from '../../PriceInput';
import FlexBox from '../../common/FlexBox';
import Scheduler from '../Scheduler';
import FlexSwitcher from '../../common/FlexSwitcher';
import NotificationUtils from '../../../utils/NotificationUtils';
import { FlexDropdown, FlexInput, FlexButton } from '../../common';

export const updateField = (props, value) => {
  const { validation, field, target, setter, postUpdate, transform } = props;
  if (validation && value != '') {
    if (validation === 'number') {
      if (isNaN(value)) {
        return;
      } else {
        value = parseFloat(value);
      }
    }
  }

  let updatedTarget = lodash.cloneDeep(target);
  const fieldTokens = field.split('.');
  let currentValue = updatedTarget;
  fieldTokens.forEach((token, index) => {
    let arrayField;
    if (token.endsWith(']')) {
      // Array
      let index = token.substring(token.indexOf('[') + 1, token.indexOf(']'));
      arrayField = token.substring(0, token.indexOf('['));
      if (currentValue[arrayField]) {
        if (!currentValue[arrayField][index]) {
          currentValue[arrayField][index] = {};
          currentValue = currentValue[arrayField][index];
        } else {
          currentValue = currentValue[arrayField][index];
        }
      }
    } else {
      if (index == fieldTokens.length - 1) {
        if (arrayField) {
          if (transform) {
            transform(
              updatedTarget,
              currentValue[arrayField],
              arrayField,
              value,
            );
          } else {
            currentValue[arrayField] = value;
          }
        } else {
          if (transform) {
            if (!currentValue[token]) {
              currentValue[token] = {};
            }
            currentValue[token] = transform(
              updatedTarget,
              currentValue[token],
              token,
              value,
            );
          } else {
            currentValue[token] = value;
          }
        }
      } else {
        if (!currentValue[token]) {
          if (arrayField) {
            currentValue[arrayField] = [];
          } else {
            currentValue[token] = {};
          }
        }
        if (arrayField) {
          currentValue = currentValue[arrayField];
        } else {
          currentValue = currentValue[token];
        }
      }
    }
  });

  if (setter) {
    setter(updatedTarget);
  }
  if (postUpdate) {
    postUpdate(updatedTarget);
  }

  return updatedTarget;
};

const deleteField = props => {
  const { field, target, setter, postUpdate } = props;
  let updatedTarget = lodash.cloneDeep(target);
  const fieldTokens = field.split('.');
  let currentValue = updatedTarget;
  fieldTokens.forEach((token, index) => {
    let arrayField;
    if (token.endsWith(']')) {
      // Array
      let i = token.substring(token.indexOf('[') + 1, token.indexOf(']'));
      arrayField = token.substring(0, token.indexOf('['));
      if (index == fieldTokens.length - 1) {
        // delete at array index because this is last token
        currentValue[arrayField].splice(i, 1);
      } else {
        currentValue = currentValue[arrayField][i];
      }
    } else {
      if (index == fieldTokens.length - 1) {
        delete currentValue[token];
      } else {
        if (currentValue[token]) {
          currentValue = currentValue[token];
        }
      }
    }
  });

  if (setter) {
    setter(updatedTarget);
  }
  if (postUpdate) {
    postUpdate(updatedTarget);
  }

  return updatedTarget;
};

export const getFieldValue = (target, field, defaultValue) => {
  let currentValue = target;
  const fieldTokens = field.split('.');
  fieldTokens.forEach((token, index) => {
    let arrayField;
    if (currentValue != null) {
      if (token.endsWith(']')) {
        // Array
        let index = token.substring(token.indexOf('[') + 1, token.indexOf(']'));
        arrayField = token.substring(0, token.indexOf('['));
        if (currentValue[arrayField]) {
          currentValue = currentValue[arrayField][index];
        } else {
          currentValue = null;
        }
      } else {
        if (index == fieldTokens.length - 1) {
          if (arrayField) {
            currentValue = currentValue[arrayField];
          } else {
            currentValue = currentValue[token];
          }
        } else {
          if (arrayField) {
            currentValue = currentValue[arrayField];
          } else {
            currentValue = currentValue[token];
          }
        }
      }
    }
  });

  if (currentValue != null) {
    return currentValue;
  } else if (defaultValue != null) {
    return defaultValue;
  } else {
    return undefined;
  }
};

function FlexFormField(props) {
  let {
    iconPopUp,
    dependencies,
    dataTransform,
    fluid = false,
    getValueTransform,
    setValueTransform,
    dataSource,
    title,
    subtitle,
    icon,
    placeholder,
    description,
    target,
    type,
    onChange,
    onBlur,
    field,
    style,
    className,
    inline,
    defaultValue,
    transform,
    value,
    disabled,
    guttered,
    rightGutter,
    bottomGutter,
    leftGutter,
    topGutter,
    gutter = 10,
    InputProps,
    subtitleStyle,
  } = props;
  let settingInput;
  let val;

  if (props.visible === false) {
    return null;
  }
  if (field) {
    if (value === null || value === undefined) {
      val = getFieldValue(target, field, defaultValue);
    } else {
      val = value;
    }
    if (getValueTransform) {
      if (typeof getValueTransform === 'string') {
        val = eval(getValueTransform)(val);
      } else if (typeof getValueTransform === 'function') {
        val = getValueTransform(val);
      }
    }
  }
  const [localPriceInputText, setLocalPriceInputText] = useState(val);
  if (type === 'break') {
    settingInput = <div style={{ marginBottom: 10 }} />;
  } else if (type === 'divider') {
    settingInput = <Divider />;
  } else if (type === 'divider-hidden') {
    settingInput = <Divider hidden />;
  } else if (
    type === 'text_input' ||
    type === 'input_text' ||
    type === 'input' ||
    type === 'phone' ||
    type === 'email'
  ) {
    const handleInputChange = e => {
      let v = e.target.value;
      if (type === 'phone') {
        v = v.replace(/[^0-9]/g, '');
      }
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          v,
        );
      }
    };

    const handleInputBlur = e => {
      let v = e.target.value;
      if (type === 'phone') {
        v = v.replace(/[^0-9]/g, '');
      }

      if (onBlur) {
        updateField(
          {
            target: target,
            field: field,
            setter: onBlur,
            transform: transform,
          },
          e.target.value,
        );
      }
    };

    if (val === undefined) {
      val = '';
    }

    let transform = setValueTransform ? eval(setValueTransform) : undefined;
    settingInput = (
      <FlexInput
        label={props.label}
        labelPosition={props.labelPosition}
        controlled={props.controlled}
        className={styles.formFieldTextInput}
        fluid={fluid}
        value={onChange ? val : undefined}
        defaultValue={!onChange && onBlur ? val : undefined}
        transform
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    );
  } else if (type === 'number_input') {
    const handleInputChange = e => {
      if (!isNaN(e.target.value)) {
        if (onChange) {
          updateField(
            {
              target: target,
              field: field,
              setter: onChange,
              transform: transform,
              validation: 'number',
            },
            e.target.value,
          );
        }
      } else {
        let val = getFieldValue(target, field);
        if (onChange) {
          updateField(
            {
              target: target,
              field: field,
              setter: onChange,
              transform: transform,
              validation: 'number',
            },
            val,
          );
        }
      }
    };

    const handleInputBlur = e => {
      if (onBlur) {
        updateField(
          {
            target: target,
            field: field,
            setter: onBlur,
            transform: transform,
            validation: 'number',
          },
          e.target.value,
        );
      }
    };

    settingInput = (
      <FlexInput
        className={styles.formFieldTextInput}
        fluid={fluid}
        value={val}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        placeholder={placeholder}
        InputProps={InputProps}
      />
    );
  } else if (type === 'price_input') {
    const handleInputBlur = (e, pennies) => {
      if (!isNaN(pennies)) {
        if (onBlur) {
          updateField(
            {
              target: target,
              field: field,
              setter: onBlur,
              transform: transform,
            },
            pennies,
          );
        }
        setLocalPriceInputText(e);
      } else {
        setLocalPriceInputText(val);
      }
    };

    const handleInputChange = e => {
      setLocalPriceInputText(e);
    };

    settingInput = (
      <PriceInput
        className={styles.formFieldTextInput}
        fluid={fluid}
        value={localPriceInputText}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    );
  } else if (type === 'percentage_input') {
    const handleInputBlur = e => {
      let val = e.target.value;
      if (!isNaN(val)) {
        val = Number.parseInt(val);
        if (val > 100) {
          val = 100;
        } else if (val < 0) {
          val = 0;
        }
        if (onBlur) {
          updateField(
            {
              target: target,
              field: field,
              setter: onBlur,
              transform: transform,
            },
            val,
          );
        }

        setLocalPriceInputText(val);
      } else {
        setLocalPriceInputText(val);
      }
    };

    const handleInputChange = e => {
      setLocalPriceInputText(e.target.value);
    };

    settingInput = (
      <FlexInput
        className={styles.formFieldTextInput}
        label="%"
        labelPosition="right"
        fluid={fluid}
        value={localPriceInputText}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    );
  } else if (type === 'calendar') {
    const handleDateSelected = date => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          date.getTime(),
        );
      }
    };

    let selectedDates = [];
    if (val != null) {
      selectedDates.push(val);
    }

    settingInput = (
      <div className={styles.calendarContainer}>
        <Scheduler
          showTimePicker={false}
          daySelectMode={'single'}
          selectedDates={selectedDates}
          onDateSelected={handleDateSelected}
        />
      </div>
    );
  } else if (type === 'range') {
    const handleChange = e => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: setValueTransform ? eval(setValueTransform) : transform,
          },
          e.target.value,
        );
      }
    };

    settingInput = (
      <div
        className={`${styles.rangeContainer} ${
          props.fluid ? styles.fluid : undefined
        }`}
      >
        <input
          type="range"
          step={props.step}
          min={props.min}
          max={props.max}
          value={val}
          onChange={handleChange}
          className={`${props.fluid ? styles.fluid : undefined}`}
        />
      </div>
    );
  } else if (type === 'substitution_builder') {
    const addTextAtCursorLocation = newText => {
      var el = document.getElementById('lineItemDesc');
      if (el !== null) {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const elementText = val;
        let text;
        if (elementText) {
          const before = elementText.substring(0, start);
          const after = elementText.substring(end, elementText.length);
          text = before + newText + after;
        } else {
          text = newText;
        }

        el.selectionStart = el.selectionEnd = start + newText.length;
        el.focus();
        if (onChange) {
          updateField(
            {
              target: target,
              field: field,
              setter: onChange,
              transform: transform,
            },
            text,
          );
        }
      }
    };

    const handleUpdateTextArea = e => {
      let text = e.target.value;
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          text,
        );
      }

      if (onBlur) {
        updateField(
          {
            target: target,
            field: field,
            setter: onBlur,
            transform: transform,
          },
          text,
        );
      }
    };

    let clickableOptions = [];
    let clickableOptionContainer;
    if (props.substitutions) {
      const { standard, unique } = props.substitutions;
      if (standard) {
        clickableOptions = standard.map(option => {
          let optionKey = option;
          let optionText = option.replaceAll('_', ' ');
          return (
            <div
              onClick={() => addTextAtCursorLocation(`{{${optionKey}}}`)}
              className={styles.substitutionOption}
            >
              {optionText}
            </div>
          );
        });

        clickableOptionContainer = (
          <FlexBox topGutter row wrap>
            {clickableOptions}
          </FlexBox>
        );
      }
    }

    settingInput = (
      <FlexBox row align="stretch">
        <FlexBox column hstretch flex={1}>
          <TextArea
            id="lineItemDesc"
            className={styles.inputTextArea}
            fluid
            placeholder={placeholder}
            onChange={handleUpdateTextArea}
            value={val}
          />
          {clickableOptionContainer}
        </FlexBox>
        <FlexBox column hstretch flex={1}>
          <pre
            className={styles.formattedSubBlock}
            style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}
          >
            {`${NotificationUtils.applySubstitution(
              val ? val : '',
              NotificationUtils.getTestObjects(target),
            )}`}
          </pre>
        </FlexBox>
      </FlexBox>
    );
  } else if (type === 'text_area') {
    const handleUpdateTextArea = e => {
      let text = e.target.value;
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          text,
        );
      }

      if (onBlur) {
        updateField(
          {
            target: target,
            field: field,
            setter: onBlur,
            transform: transform,
          },
          text,
        );
      }
    };
    let transform = setValueTransform ? eval(setValueTransform) : undefined;
    settingInput = (
      <TextArea
        className={styles.inputTextArea}
        fluid
        rows={12}
        transform
        placeholder={placeholder}
        onChange={handleUpdateTextArea}
        value={val}
      />
    );
  } else if (type === 'time') {
    let minimumDate = new Date();
    let initialYear = minimumDate.getYear() + 1900;
    let resultMonth = minimumDate.getMonth();
    let monthDayNum = minimumDate.getDate();
    let time = new Date(initialYear, resultMonth, monthDayNum).getTime();
    let timeInDayMillis = 0;

    let currDayNum = monthDayNum;
    const timeframeWindowOptions = [];
    while (monthDayNum === currDayNum) {
      timeframeWindowOptions.push({
        key: timeInDayMillis,
        value: timeInDayMillis,
        text: new Date(time).toLocaleTimeString('en-us', {
          hour: '2-digit',
          minute: '2-digit',
        }),
      });
      timeInDayMillis += 1000 * 60 * 15;
      time += 1000 * 60 * 15;
      let currDate = new Date(time);
      currDayNum = currDate.getDate();
    }

    const handleTimeSelected = ({ value }) => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          value,
        );
      }
    };

    settingInput = (
      <FlexDropdown
        selection
        fluid
        options={timeframeWindowOptions}
        value={val}
        onChange={handleTimeSelected}
      />
    );
  } else if (type === 'table') {
    settingInput = (
      <FlexTable noscroll basic columns={props.columns} rows={props.rows} />
    );
  } else if (type === 'dropdown') {
    const handleDropdownOnChange = ({ value }) => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: setValueTransform ? eval(setValueTransform) : transform,
          },
          value,
        );
      }
    };
    let options = props.options;
    if (dataTransform && dataSource) {
      let tranny = eval(dataTransform);
      options = tranny(dataSource);
    }

    if (typeof options === 'object') {
      if (options.dependency) {
        let dep = dependencies[options.dependency];
        if (dep) {
          if (Array.isArray(dep)) {
            options = dep.map(option => {
              return {
                key: option,
                text: option,
                value: option,
              };
            });
          }
        }
      }
    }

    transform = setValueTransform ? eval(setValueTransform) : transform;
    settingInput = (
      <FlexDropdown
        material={props.material}
        style={{ minWidth: 175 }}
        defaultValue={defaultValue}
        hstretch={fluid}
        showValueSubtext={props.showValueSubtext}
        selection
        placeholder={placeholder}
        options={options}
        transform
        value={val}
        onChange={handleDropdownOnChange}
      />
    );
  } else if (type === 'switch') {
    const handleSwitchChange = value => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          value,
        );
      }
    };

    settingInput = (
      <FlexSwitcher
        fillWidth={fluid}
        options={props.options}
        value={val}
        onChange={handleSwitchChange}
      />
    );
  } else if (type === 'toggle') {
    if (inline !== false) {
      inline = true;
    }
    const handleToggleChange = e => {
      if (onChange) {
        updateField(
          {
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          },
          !val,
        );
      }
    };

    settingInput = (
      <FlexBox row align="center">
        {props.inlineLabel && (
          <div className={styles.inlineLabel}>{props.inlineLabel}</div>
        )}
        <Checkbox toggle checked={val} onChange={handleToggleChange} />
      </FlexBox>
    );
  } else if (type === 'button') {
    if (props.action === 'delete') {
      const handleClick = e => {
        if (onChange) {
          deleteField({
            target: target,
            field: field,
            setter: onChange,
            transform: transform,
          });
        }
      };

      settingInput = <FlexButton icon="times" fitted onClick={handleClick} />;
    } else {
      const handleClick = e => {
        onChange(e);
      };

      settingInput = (
        <FlexButton icon={props.icon} text={props.text} onClick={handleClick} />
      );
    }
  }

  let formFieldStyle = {};
  if (style) {
    formFieldStyle = { ...style };
  }

  if (disabled) {
    formFieldStyle.opacity = 0.5;
    formFieldStyle.pointerEvents = 'none';
  }

  if (rightGutter || guttered) {
    formFieldStyle.paddingRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    formFieldStyle.paddingBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    formFieldStyle.paddingLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    formFieldStyle.paddingTop = `${gutter}px`;
  }

  if (props.bordered) {
    formFieldStyle.padding = '15px';
    formFieldStyle.border = '1px solid rgba(0,0,0,0.1)';
    formFieldStyle.borderRadius = '8px';
  }

  if (fluid) {
    formFieldStyle.width = '100%';
  }

  const handleFieldAction = option => {
    if (props.onFieldAction) {
      props.onFieldAction(option);
    }
  };

  if (inline) {
    let frontInput;
    let backInput;
    if (type === 'toggle') {
      backInput = <div className={styles.formFieldInput}>{settingInput}</div>;
    } else {
      backInput = <div className={styles.formFieldInput}>{settingInput}</div>;
    }

    return (
      <div style={formFieldStyle} className={styles.formField}>
        <FlexBox row align="center">
          {frontInput}
          <FlexBox flex={1} column style={{ paddingRight: 50 }}>
            {(title || subtitle) && (
              <div className={styles.formFieldTitle}>
                {icon && (
                  <div className={`${styles.formFieldIcon} material-icons`}>
                    {iconPopUp ? (
                      <Popup
                        content={iconPopUp}
                        trigger={<span>{icon}</span>}
                      />
                    ) : (
                      <>{icon}</>
                    )}
                  </div>
                )}
                <FlexBox column>
                  {props.fieldOptions && title && (
                    <FlexDropdown
                      style={{ minHeight: 25, marginBottom: 0 }}
                      compact
                      transparent
                      text={title}
                      options={props.fieldOptions}
                      onChange={handleFieldAction}
                    />
                  )}
                  {!props.fieldOptions && title}
                  {subtitle && (
                    <div
                      style={{
                        marginBottom: !props.compact ? 5 : 0,
                        ...(subtitleStyle || {}),
                      }}
                      className={styles.formFieldSubtitle}
                    >
                      <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                    </div>
                  )}
                </FlexBox>
              </div>
            )}
            {description && (
              <div className={styles.formFieldDesc}>{description}</div>
            )}
          </FlexBox>
          {backInput}
        </FlexBox>
      </div>
    );
  } else {
    return (
      <div style={formFieldStyle} className={styles.formField}>
        {props.note && <div className={styles.formFieldNote}>{props.note}</div>}
        {(title || subtitle) && (
          <div
            style={{
              marginBottom: !subtitle && !description && !props.compact ? 5 : 0,
            }}
            className={styles.formFieldTitle}
          >
            {icon && (
              <div className={`${styles.formFieldIcon} material-icons`}>
                {iconPopUp ? (
                  <Popup content={iconPopUp} trigger={<span>{icon}</span>} />
                ) : (
                  <>{icon}</>
                )}
              </div>
            )}
            <FlexBox column align="flex-start">
              {props.fieldOptions && title && (
                <FlexDropdown
                  style={{ minHeight: 25, marginBottom: 0 }}
                  compact
                  transparent
                  text={title}
                  options={props.fieldOptions}
                  onChange={handleFieldAction}
                />
              )}
              {!props.fieldOptions && title}
              {subtitle && (
                <div
                  style={{
                    ...(subtitleStyle || {}),
                  }}
                  className={styles.formFieldSubtitle}
                >
                  <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                </div>
              )}
              {props.subcontent}
            </FlexBox>
          </div>
        )}
        {description && (
          <div className={styles.formFieldDesc}>{description}</div>
        )}
        <div className={styles.formFieldInput}>{settingInput}</div>
      </div>
    );
  }
}

FlexFormField.propTypes = {};

export default FlexFormField;
